
angular.module('trainerWebApp.controllers').controller('ManageShopifyCoursesCtrl',
  ['$scope', '$rootScope', '$window', 'mtypes', '$location', 'gridFormatters', 'Validation', '$routeParams', 'userGridUtils', 'accountFeatures', 'authView', 'resolveData', 'shopifyResource', function ($scope, $rootScope, $window, mtypes, $location, gridFormatters, Validation,
            $routeParams, userGridUtils, accountFeatures, authView, resolveData, shopifyResource) {

    // enforce catalog feature
    //if (!~accountFeatures.features.indexOf(mtypes.featureEntry.courseCatalog) && !authView.isActiveAdvancedtrial()) {
    //  $location.path('/TMS/Home');
    //  return;
    //}


    $window.document.title = "Manage Shopify Courses for Sale | Mindflash Training Management System";
    $rootScope.page = {name: 'manageShopifyCourses', title: "manageShopifyCourses"};

    $scope.gridData = _.sortBy(resolveData.items, function(item){ return (item.name || "").toLowerCase(); });
    var signupUrl = resolveData.signupUrl;
    
    $scope.viewState = {
      shopName: resolveData.shopName,
      authCode: $location.search().code,
      enteredShopName: parseShopifyUrlForEntry($location.search().shop),
      currentEditCellId: ''
    };
    
    resolveData = null;
    
    function getGridColumns() {
      return [
        {id: "delete", name: "", field: "id", width:35, minWidth: 35, maxWidth: 35, cssClass: "", headerCssClass: "header-column", sortable: false, formatter: delButtonFormatter},
        {id: "thumb", name: "", field: "thumb", width: 150, minWidth: 150, maxWidth: 150, cssClass: "cell-title", headerCssClass: "header-column", sortable: false, formatter: thumbFormatter},
        {id: "name", name: "Name", field: "name", maxWidth: 200, cssClass: "catalog-add-item-name", headerCssClass: "header-column-first", sortable: true},
        {id: "type", name: "Type", field: "type", maxWidth: 80, cssClass: "cell-title", headerCssClass: "header-column-first", sortable: true},
        {id: "description", name: "Description", field: "description", minWidth: 200,  cssClass: "slick-cell-wrap", headerCssClass: "header-column", sortable: false},
        {id: "price", name: "Price", field: "price", minWidth: 150, maxWidth: 150, cssClass: "cell-title", headerCssClass: "header-column-first", sortable: true, formatter: priceFormatter, editor: priceEditor}
      ];
    }

    var gridCommands = $scope.gridCommands = {};
    $scope.gridInfo = {
      options: {
        editable: true,
        enableCellNavigation: true,
        asyncEditorLoading: false,
        forceFitColumns: true,
        forceSyncScrolling: $scope.gridData.length < 500,
        multiColumnSort: true,
        rowHeight: 85,
        autoEdit: true
      },
      columns: getGridColumns(),
      onBeforeCellEditorDestroy: updatePrice,
      data: []
    };

    init();
    
    function init() {

      parseShopifyUrlForEntry();

      if($scope.viewState.authCode) {
        connectAccountToShopify();  
      }
    }
    
    function connectAccountToShopify() {
      // this happens when shopify has called back with an auth code for a new shopify connection
      
      // do nothing if we already have a shopify connection
      if($scope.viewState.shopName) return;

      $rootScope.$broadcast('$showLoadingSpinner', true);
      shopifyResource.initShopify($location.search(), function(result) {
        if(result && result.success) {
          // yay, success
          $scope.viewState.shopName = result.shopifyShopName;
          $location.url($location.path());
        } else {
          // some problem with connecting procedure or data, look in error field
        }
        $rootScope.$broadcast('$showLoadingSpinner', false);
      }, function(err) {
        // something went wrong with the call
        $rootScope.$broadcast('$showLoadingSpinner', false);
      });
    }
    
    function parseShopifyUrlForEntry(shopUrl) {
      if (!shopUrl) return null;
      
      var pattern = new RegExp("(.+)\.myshopify\.com", "i");
      var matches = pattern.exec(shopUrl);
      if (matches.length > 1) {
        return matches[1];
      }
      return null;
    }
    
    function delist(item) {
      if (!item || !item.id) return;

      $rootScope.$broadcast('shopifyCourseDeletionRequestedEvent', item);
    }

    function updatePrice(item, oldPrice){
      var validation = isItemFloat(item.price);
      if(!validation){
        item.price = oldPrice;
        return;
      }

      var contentToUpdate = _.pick(item, 'id', 'sid', 'vid', 'price', 'name', 'type');
      shopifyResource.updateCourses({courses: [contentToUpdate]}, function(result) {
        //yay, success
      }, function(err) {
        // something went wrong with the call
      });
    }

    function isItemFloat(price){
      return !isNaN(parseFloat(price));
    }

    $scope.$on('shopifyCourseDeletionConfirmedEvent', function(event, item, cb) {
      // call server to delist, and update grid
      var contentToUpdate = _.pick(item, 'id', 'sid', 'vid', 'price', 'name', 'type');
      shopifyResource.delist(contentToUpdate, function(result) {
        removeItemFromGridByShopifyId(item.sid);
        (cb || angular.noop)();
      }, function(err) {
        (cb || angular.noop)();
      });
    });

    function removeItemFromGridByShopifyId(sid) {
      $scope.gridData = _.filter($scope.gridData, function(item) {
        return item.sid != sid;
      });
    }
    
    function thumbFormatter(row, cell, value, columnDef, item) {
      return '<div class="shopify-slick-formatter"><img class="catalog-item-thumbnail" src="' + item.thumbUrl + '"/></div>';
    }

    function priceFormatter(row, cell, value, columnDef, item) {
      return "$"+item.price + '<i class="icon-pencil pull-right pointer-cursor"></i>';
    }

    function delButtonFormatter(row, cell, value, columnDef, item) {
      return '<div class="del shopify-slick-formatter" id="'+ item.id +'"><i class="icon-remove-sign" style="cursor:pointer;font-size:18px;"></i></div>';
    }

    // TODO: Iverson I think this is not properly removed
    $(document).on('click', '.del', function() {
      var me = $(this), id = me.attr('id');
      var item = gridCommands.getItemById(id);
      delist(item);
    });

    function priceEditor(args) {
      var $priceField;
      var scope = this;

      this.init = function () {
        $(args.container).append("$ ");
        
        $priceField = $("<INPUT type=text style='width:60px' />")
          .appendTo(args.container)
          .bind("keydown", scope.handleKeyDown);

        scope.focus();
      };

      this.handleKeyDown = function (e) {
        if(e.keyCode == $.ui.keyCode.LEFT || e.keyCode == $.ui.keyCode.RIGHT){
          e.stopImmediatePropagation();
        }
        else if (e.keyCode == $.ui.keyCode.TAB || e.keyCode == $.ui.keyCode.ENTER) {
          gridCommands.navigateLeft();
        }
      };

      this.destroy = function () {
        $(args.container).empty();
      };

      this.focus = function () {
        $priceField.focus();
      };

      this.serializeValue = function () {
        return {price: parseFloat($priceField.val())};
      };

      this.applyValue = function (item, state) {
        var oldPrice = item.price;
        item.price = state.price;
        updatePrice(item, oldPrice);
      };

      this.loadValue = function (item) {
        $priceField.val(item.price);
      };

      this.isValueChanged = function () {
        return args.item.price != parseFloat($priceField.val());
      };

      this.validate = function () {
        return {valid: true, msg: null};
      };

      this.init();
    }
    
    $scope.onAddContentClick = function() {
      $location.path('TMS/Shopify/addShopifyContent');
    };
    
    $scope.connectToShopify = function() {
      if(!signupUrl) return;
      $rootScope.$broadcast('$showLoadingSpinner', true);
      $window.location.href = signupUrl.replace("{shop}", $scope.viewState.enteredShopName);
    };

    $scope.$on('$destroy', function() {
        $(document).off('click', '.del');
    });
  }]
);
